import { SESSION_POST_LOGIN_CHAT_RESET_PENDING } from '@/constants';
import { useEffect } from 'react';

export const MicrosoftLoginRedirect = () => {
  useEffect(() => {
    sessionStorage.setItem(SESSION_POST_LOGIN_CHAT_RESET_PENDING, '1');
    window.location.href = `${import.meta.env.VITE_FLETCH_API_URL}/fletch/login`;
  }, []);

  return <div>Redirecting to Microsoft Login...</div>;
};
